import { memo } from "react"

const ArrowRightIcon = () => {
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.05 7.97L10.05 0.969996C9.85706 0.782431 9.57872 0.712038 9.31983 0.785332C9.06093 0.858627 8.8608 1.06447 8.79483 1.32533C8.72885 1.58619 8.80706 1.86243 8.99998 2.05L14.71 7.75H1.47998C1.06577 7.75 0.72998 8.08578 0.72998 8.5C0.72998 8.91421 1.06577 9.25 1.47998 9.25H14.7L8.99998 14.95C8.85703 15.0893 8.77641 15.2804 8.77641 15.48C8.77641 15.6796 8.85703 15.8707 8.99998 16.01C9.13782 16.1546 9.33023 16.2345 9.52998 16.23C9.72905 16.2309 9.9201 16.1516 10.06 16.01L17.06 9.01C17.3524 8.71718 17.3524 8.24281 17.06 7.95L17.05 7.97Z"
        fill="white"
      />
    </svg>
  )
}

export default memo(ArrowRightIcon)
